import React from 'react';
import {IndexRoute, Route} from 'react-router';
import App from './containers/App';
import HomePage from './containers/HomePage';
import ResultsPage from './containers/ResultsPage'
import RacesPage from "./containers/RacesPage";


export default (
	<Route path="/" component={App}>
		{<IndexRoute component={HomePage}/>}
		{<Route path="/:seasonId" component={RacesPage}/>}
		{<Route path="/:seasonId/:eventId/:raceId(/:compGroupId(/:tab))" component={ResultsPage}/>}
	</Route>
);


// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/routes.js